import { render, staticRenderFns } from "./AnnounceDetail.vue?vue&type=template&id=830a7af6&scoped=true&"
import script from "./AnnounceDetail.vue?vue&type=script&lang=js&"
export * from "./AnnounceDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceDetail.vue?vue&type=style&index=0&id=830a7af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830a7af6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VContainer,VDivider,VRow,VSpacer})
